// Categories refer to Cookie Banner library categories (they are not Google Analytics consent categories)
export type CookieCategories =
  | 'necessary'
  | 'analytics'
  | 'marketing'
  | 'functional';

export type ConsentString = 'granted' | 'denied';
export type ConsentParams = {
  /** Enables storage (cookies / device IDs) related to analytics (e.g., GA4 identifiers).
   *  If denied, Google may use modeled data depending on your setup.
   *  Source: Google Consent Mode “analytics_storage”. */
  analytics_storage: ConsentString;

  // ------- THESE ARE NOT USED IN THIS APPLICATION YET ------- //

  // /** Enables storage that supports site/app functionality (e.g., language, region, UI prefs).
  //  *  Not used for advertising or analytics; purely functional storage.
  //  *  Source: Tag Manager/Ads Help “functionality_storage”. */
  // functionality_storage: ConsentString;

  // /** Enables storage (cookies / device IDs) related to advertising.
  //  *  Controls whether ad tags can use ad-related identifiers (affects conversion tracking & remarketing).
  //  *  Source: Google Consent Mode “ad_storage”. */
  // ad_storage: ConsentString;

  // /** Sets consent for sending user data to Google for online advertising purposes
  //  *  (separate from storage). Think “can Google receive ad-related user data at all?”
  //  *  Source: Google Consent Mode “ad_user_data”. */
  // ad_user_data: ConsentString;

  // /** Sets consent for personalized advertising (e.g., remarketing/interest-based ads).
  //  *  If denied, ads should be non-personalized even if ad_user_data is granted.
  //  *  Source: Google Consent Mode “ad_personalization”. */
  // ad_personalization: ConsentString;

  // /** Enables storage related to content personalization on the site/app
  //  *  (e.g., video recommendations), separate from ads personalization.
  //  *  Source: Tag Manager/Ads Help “personalization_storage”. */
  // personalization_storage?: ConsentString;
};

export const CROCS_COOKIE_CONSENT_STORAGE_KEY = '_crocs_cookie_consent';

export const DEFAULT_CONSENT_OPTIONS: ConsentParams = {
  analytics_storage: 'denied',
  // COOKIES: Leave it here in case we add these cookies in the future
  // functionality_storage: 'denied',
  // ad_personalization: 'denied',
  // ad_storage: 'denied',
  // ad_user_data: 'denied',
  // functionality_storage: 'denied',
  // personalization_storage: 'denied',
};
